module.exports = __webpack_public_path__ + "static/img/u306.5b3d8d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u306.png
// module id = k+FP
// module chunks = 1